import { PROVINCES, STEPS_OPTIONS } from 'store/enums';
import getters from './getters';
import actions from './actions';
import mutations from './mutations';

const state = {
  loader: true,
  loaderText: null,
  streetType: null,
  documentType: null,
  maritalStatus: null,
  financialIncomes: null,
  provinces: PROVINCES,
  profession: null,
  sex: null,
  signType: null,
  stepsOptions: STEPS_OPTIONS,
  stepsNumber: STEPS_OPTIONS.length,
  headerLogos: {
    logoFrontLeft: null,
    logoFrontRight: null
  },
  footerLogos: [],
  theme: 'ald-bbva',
  footerPubli: null,
  urlFooterLastStep: null,
  disclaimer: null,
  townsCache: {},
  legal: {},
  errorPage: {
    notFound: '',
    api: ''
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
